<template>
  <div class="industry">
    <div class="title-font-style">工业解决方案</div>
    <div class="illustrate">
      <div>使用XR技术模拟复杂机械设备的装配、调试、维修维护等专业操作培训，提高员工培训效率，降低操作失误率，减少安全风险，为企业降本增效。</div>
    </div>
    <div class="subtitle">行业痛点</div>
    <div>
      <div class="disadvantage">伴随着工业领域的产业技术升级，数字化工厂的建设对企业传统培训做业流程提出新的挑战。工作流程复杂，设备操作复杂的特定行业需要高效的标准化的操作流程培训与考核。</div>
    </div>
    <div class="hytd-box">
      <div class="hytd">
        <div v-for="(item, index) in prospects" :key="index">
          <div class="images">
            <img :src="item.url" />
          </div>
          <div>
            <div class="title">
              <img :src="item.src" />
              <span>{{ item.title }}</span>
            </div>
            <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="subtitle">方案优势</div>
    <div class="fays">
      <img :src="loadUrl.fays_bg" />
      <div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/xiaolv.png" />
            <span>培训效率提升</span>
          </div>
          <div>XR可视化培训相比传统方式，更为直观易学，有效缩短员工培训时间，提高培训效率。</div>
        </div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/zaozuo.png" />
            <span>操作流程规范</span>
          </div>
          <div>AR标准化操作流程指导，配置可视化参数，规范员工作业过程，提升员工工作质量，从而提高企业效率。</div>
        </div>
      </div>
      <div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/hudong.png" />
            <span>互动参与感强</span>
          </div>
          <div>基于实际环境、设备，以三维化多媒体素材为主，过程多样化智能交互，减少对传统纸质手册和专家的依赖，并结合具体情况提供更适合的情景培训。</div>
        </div>
        <div>
          <div class="title">
            <img src="@/assets/images/solution/zichan.png" />
            <span>沉淀数字资产</span>
          </div>
          <div>培训过程中不断积累沉淀企业数字化内容，形成企业自有知识库。</div>
        </div>
      </div>
    </div>
    <div class="yycj">
      <div class="subtitle">应用场景</div>
      <div class="yycj-content">
        <img :src="loadUrl.industryMp4" />
      </div>
    </div>
    <div class="yyal">
      <div class="subtitle">应用案例</div>
      <div class="yyal-content">
        <div v-for="(item, index) in casesListAll" :key="index" @click="toDetail(item.relatedHtmlId, item.title)">
          <img :src="item.ossPath" />
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div class="detail">
              {{ item.introduction }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()
const casesListAll: any = ref([])
const prospects = [
  {
    title: '互动性较弱',
    content: '传统培训模式互动性和参与感较弱，缺乏场景感，无法达到真实工作环境下的实操模拟培训及考核要求。',
    url: require('@/assets/images/solution/disadvantage1.png'),
    src: require('@/assets/images/solution/disadvantage-icon1.png')
  },
  {
    title: '数字化不足',
    content: '传统培训模式在实际操作过程中缺少量化参数及考核数据，无法形成企业组织培训数字化资产。',
    url: require('@/assets/images/solution/disadvantage2.png'),
    src: require('@/assets/images/solution/disadvantage-icon2.png')
  },
  {
    title: '培训成本高',
    content: '高危行业传统新员工操作培训成本高并带有安全风险，培训成本高，培训效率亟待提高。',
    url: require('@/assets/images/solution/disadvantage3.png'),
    src: require('@/assets/images/solution/disadvantage-icon3.png')
  }
]

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesListAll.value = [...res].filter(e => e.industry == 2).sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0)) || []
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const industryMp4: any = await asynchronousRetrieval('webimg/gif/industry.gif');
  loadUrl.value = { fays_bg, industryMp4 }
})
</script>
<style scoped lang="less">
.industry {
  padding-top: 60rem;
  overflow: hidden;
  width: 100vw;

  .illustrate {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16rem 0 80rem;

    &>div {
      font-weight: 400;
      font-size: 24rem;
      color: #4A4A4A;
      width: 600rem;
      line-height: 36rem;
    }
  }

  .subtitle {
    position: relative;
    font-weight: 600;
    font-size: 32rem;
    color: #000000;
    line-height: 44rem;
    display: inline-block;
    padding: 0 16rem;

    &::after {
      content: '';
      width: 100%;
      height: 20rem;
      background: rgba(35, 117, 255, 0.2);
      position: absolute;
      left: 0;
      bottom: -5rem;
    }
  }

  .disadvantage {
    width: 600rem;
    display: inline-block;
    box-sizing: border-box;
    border-radius: 8rem;
    margin: 44rem 0 38rem;
    color: #5D5D5D;
    font-size: 20rem;
    line-height: 30rem;
  }

  .hytd-box {
    width: 100vw;
    margin-bottom: 80rem;
    overflow: hidden;
    overflow-x: auto;

    .hytd {
      width: 1392rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 120rem;

      &>div {
        width: 448rem;
        font-size: 0;
        box-shadow: 0 0 7rem 0 rgba(0, 0, 0, 0.1);
        border-radius: 8rem;
        overflow: hidden;

        &>div {
          padding: 28rem 18rem;
          font-weight: 400;
          font-size: 20rem;
          color: #5D5D5D;
          line-height: 30rem;
          text-shadow: 0 0 7rem rgba(0, 0, 0, 0.1);
          text-align: left;
          height: 254rem;
          box-sizing: border-box;
          background: #FFFFFF;

          .title {
            font-weight: 600;
            font-size: 28rem;
            color: #000000;
            text-shadow: 0 0 7rem rgba(0, 0, 0, 0.1);
            font-family: PingFangSC-Medium;
            margin-bottom: 18rem;

            img {
              width: 70rem;
              height: auto;
              vertical-align: middle;
            }

            span {
              vertical-align: middle;
            }
          }

          &>div:last-child {
            padding: 0 14rem;
            line-height: 30rem;
          }
        }
      }

      .images {
        width: 100%;
        height: 302rem;
        background: #F2F4FA;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0;
        font-size: 0;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .fays {
    position: relative;
    width: 100vw;
    height: 674rem;
    margin-top: 48rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    padding: 0 14.5rem;
    box-sizing: border-box;

    &>img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    &>div {
      // width: 513rem;
      height: 674rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 33rem 0;
      box-sizing: border-box;

      &>div {
        width: 356rem;
        height: 300rem;
        background-color: #fff;
        border-radius: 8rem;
        backdrop-filter: blur(10rem);
        font-weight: 400;
        font-size: 20rem;
        color: #414141;
        line-height: 30rem;
        padding: 20rem;
        box-sizing: border-box;
      }

      .title {
        font-weight: 600;
        font-size: 24rem;
        color: #000000;
        line-height: 30rem;
        font-family: PingFangSC-Medium;

        img {
          width: 80rem;
          height: 77rem;
          vertical-align: middle;
        }

        span {
          vertical-align: middle;
        }
      }

      &>div>div:last-child {
        padding: 10rem;
      }
    }
  }

  .yycj {
    padding-top: 64rem;

    .yycj-content {
      width: 100%;
      height: 382rem;
      margin-top: 48rem;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 680rem;
        height: 100%;
        border: 1px solid #979797;
        border-radius: 24rem;
      }
    }
  }

  .yyal {
    padding-top: 64rem;
    overflow: hidden;

    .yyal-content {
      margin: 46rem 0 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      &>div {
        width: 680rem;
        background: #FFFFFF;
        border-radius: 32rem;
        box-sizing: border-box;
        cursor: pointer;
        padding: 24rem 24rem 34rem;
        margin-bottom: 48rem;

        &:hover {
          box-shadow: 0px 10px 12px 0px rgba(46, 118, 255, 0.2), 0px 0px 4px 0px rgba(46, 118, 255, 0.2);
        }

        img {
          width: 630rem;
          height: 354rem;
          border-radius: 20rem;
        }

        .content {
          width: 632rem;
          text-align: left;
          font-weight: 600;
          font-size: 16rem;
          color: #0A0A0A;
          line-height: 22rem;
          font-family: PingFangSC-Medium;

          .title {
            font-weight: 600;
            font-size: 30rem;
            color: #414141;
            line-height: 48rem;
            margin-top: 10rem;
          }

          .detail {
            font-weight: 400;
            font-size: 20rem;
            color: #414141;
            line-height: 30rem;
            margin-top: 6rem;
            font-family: PingFangSC-Regular;
          }
        }
      }
    }
  }
}
</style>